<template>
  <div class="administration-wrapper">
    <Nav/>
    <News v-if="$route.query.page === 'news'"/>
    <Message v-else-if="$route.query.page === 'message'"/>
    <div v-else class="news-header">
      <h2>Новини</h2>
    </div>
    <img class="mobile-logo" src="../../assets/img/logo.svg" alt="KCM">
    <p class="mobile-message">Администрацията е предвидена за работа от десктоп устройства.</p>
    <p class="cdots">&copy; Решението е разработено от <a href="https://cdots-corporation.com/" target="_blank" class="basic-link">cDots Corporation</a>, 2019</p>
  </div>
</template>

<script>
import Nav from "./shared/Nav";
import News from "./news/News";
import Message from "./message/Message";
export default {
  components: {
    Nav,
    News,
    Message
  },
  mounted() {
    this.$router.push({ path: "/administration?page=news&type=news" });
  }
};
</script>

<style lang="scss" scoped>
.administration-wrapper {
  background-color: #d1d8de;
  height: 100vh;
  overflow: auto;
  padding: 10px 10px 10px 270px;
}
p {
  text-align: center;
}
.news-header {
  align-items: center;
  display: flex;
  height: 40px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 10px;
  width: 100%;
  width: 900px;
  h2 {
    color: #004785;
    font-size: 14px;
    font-weight: 500;
  }
}
.mobile-message,
.mobile-logo,
.cdots {
  display: none;
}

@media screen and (max-width: 1000px) {
  .administration-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
  }
  .mobile-message,
  .mobile-logo,
  .cdots {
    display: block;
  }
  .mobile-logo {
    width: 200px;
  }
  .mobile-message {
    margin: 15px 0;
  }
  .cdots {
    font-size: 9px;
    opacity: 0.7;
  }
}
</style>
